import { TranslateService } from '@ngx-translate/core';
import { ReferenceType } from '@shared/references.model';

/** The base/default currency, pinned to the top of currency selectors. */
const BASE_CURRENCY_CODE = 'USD';

/**
 * Orders currency reference types for display: the base currency (USD) first, then the remaining
 * currencies alphabetically by their translated label (locale-aware). Returns a new array; the
 * input is not mutated. If translations are not yet loaded, `instant` falls back to the key, which
 * still yields a stable order with USD pinned first.
 */
export function sortCurrencyTypesForDisplay(
  currencyTypes: ReferenceType[],
  translateService: TranslateService
): ReferenceType[] {
  if (!currencyTypes) {
    return currencyTypes;
  }
  const label = (type: ReferenceType): string =>
    translateService.instant(`currency-type.${type.id}`);
  return [...currencyTypes].sort((a, b) => {
    if (a.id === BASE_CURRENCY_CODE || b.id === BASE_CURRENCY_CODE) {
      if (a.id === b.id) {
        return 0;
      }
      return a.id === BASE_CURRENCY_CODE ? -1 : 1;
    }
    return label(a).localeCompare(label(b));
  });
}
